export default {
  name: 'OpenQuestionBtn',

  props: {
    extraClasses: {
      type: String,
      default: () => '',
    },
  },

  methods: {
    openQuestion() {
      this.$emit('open-question');
    },
  },
};
